import React, { useEffect } from "react";
import Banner from "../Common_Component/Banner/Banner";
import OurMission from "./OurMission/OurMission";
import OurTeam from "./OurTeam/OurTeam";
import SetsUsApart from "./SetsUsApart/SetsUsApart";
import CoreValues from "./CoreValues/CoreValues";
import JourneyToSuccess from "./JourneyToSuccess/JourneyToSuccess";
import Industries_We_Serve from "./Industries_We_Serve/Industries_We_Serve";
import About_Us_Below_Banner_section from "../Common_Component/Below_Banner_section/About_Us_Below_Banner_section";
import Founder from "./Founder/Founder";
import Counter from "./Counter/Counter";

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <>
      <Banner videoSrc={"/Assets/Vedio/About_Us/About_Us.mp4"} />
      <About_Us_Below_Banner_section
        headingText={"About ReachOut Media Tech Pvt. Ltd."}
        ContentText={
          "At ReachOut Media Tech Pvt. Ltd., we specialize in crafting creative, data-driven advertising strategies that deliver results. We offer a unique combination of digital screens, print media all designed to elevate your brand and connect you with your target audience."
        }
      />
      <OurMission />
      {/* <Founder /> */}
      <Industries_We_Serve />
      <SetsUsApart />
      <OurTeam />
      <CoreValues />
      <JourneyToSuccess />
    </>
  );
};

export default AboutUs;
